import React from 'react';
import Modal from './Modal';

/**
 * Generic EntityModal component for CRUD operations
 * Wraps Modal with a Form component for any entity type
 *
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} onClose - Callback when modal is closed
 * @param {object|null} entity - The entity to edit (null for create)
 * @param {string} entityName - Display name for the entity (e.g., "Company", "Contact")
 * @param {string} entityPropName - Prop name passed to form (e.g., "deal" for DealForm)
 * @param {React.Component} FormComponent - The form component to render
 * @param {function} onSubmit - Callback when form is submitted
 * @param {boolean} loading - Whether the form is in loading state
 * @param {string} size - Modal size ('sm', 'md', 'lg', 'xl')
 */
const EntityModal = ({
  isOpen,
  onClose,
  entity = null,
  entityName,
  entityPropName,
  FormComponent,
  onSubmit,
  loading = false,
  size = 'lg',
}) => {
  // Use entityPropName if provided, otherwise derive from entityName
  const propName = entityPropName || entityName.toLowerCase();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={entity ? `Edit ${entityName}` : `New ${entityName}`}
      size={size}
    >
      <FormComponent
        {...{ [propName]: entity }}
        onSubmit={onSubmit}
        onCancel={onClose}
        loading={loading}
      />
    </Modal>
  );
};

export default EntityModal;
